import type { ColumnConfig, SalesHierarchyNode } from "../types"
import { type OpportunityScenarioView } from "./opportunities"
import { ViewMode } from "../types"
import { buildForecastTableHierarchy, summarizeForecastHierarchyTotals } from "./forecast_table_pipeline"

export interface PlanTotalsSnapshot {
  total_dollars: number
  actual_dollars: number
  forecast_dollars: number
}

/** Totals for confirmation / changelog baseline (plan-column months, same as KPIs). */
export function computePlanTotalsSnapshot(
  raw_data: SalesHierarchyNode[],
  viewMode: ViewMode,
  opportunityScenarioView: OpportunityScenarioView,
  selectedOpportunityIds: Set<string>,
  period_keys: string[],
  column_config?: ColumnConfig,
  /** Mirror the grid's Opportunities toggle so the dialog's absolutes match the KPIs on screen. */
  include_open_opportunities?: boolean
): PlanTotalsSnapshot {
  const tree = buildForecastTableHierarchy(raw_data, viewMode, opportunityScenarioView, selectedOpportunityIds, {
    include_open_opportunities,
  })
  const live = summarizeForecastHierarchyTotals(
    tree,
    period_keys.length > 0 ? period_keys : null,
    column_config
  )
  return {
    total_dollars: live.actual_volume_dollars + live.forecast_volume_dollars,
    actual_dollars: live.actual_volume_dollars,
    forecast_dollars: live.forecast_volume_dollars,
  }
}

export function format_plan_total_currency(value: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Number.isFinite(value) ? value : 0)
}

export function format_forecast_delta_currency(delta: number): string {
  if (!Number.isFinite(delta) || delta === 0) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(0)
  }
  // A plan that went down reads "−$1,419,202", never "$1,419,202" (the old `""` sign dropped the minus).
  const sign = delta > 0 ? "+" : "−"
  return `${sign}${new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Math.abs(delta))}`
}
